import { IMember } from "@rentiohq/shared-frontend/dist/types/auth.types";
import { IDocument } from "@rentiohq/shared-frontend/dist/types/document.types";
import { IDocumentPackage } from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { IProperty } from "@rentiohq/shared-frontend/dist/types/property.types";
import { ITask } from "@rentiohq/shared-frontend/dist/types/task.types";
import { IAction } from "@rentiohq/web-shared/dist/types";

export interface IDocumentProps {
  documentId: string;
  onDrawerClose: () => void;
}

export interface ITabProps extends IDocumentProps {
  setTab: (tab: EDocumentTabs) => void;
  document: IDocument;
  documentPackage?: IDocumentPackage;
  isFetchingDocumentPackage: boolean;
  linkedProperty?: IProperty;
  linkedTask?: ITask;
  parentMembers?: IMember<any>[];
  mainActions: IAction[];
}

export enum EDocumentTabs {
  Info,
  History,
}
